import type { paths } from '../__generated__/access/database.ts';
import type { FetchOptions, FetchResponse } from 'openapi-fetch';

export * from './cache';
export * from './cached-get';
export * from './client';
export * from './client-action';
export * from '../core/errors';
export * from '../__generated__/access/database';
export * from '../__generated__/access/validators';

export type ApiResponse<Method extends 'get' | 'post' | 'put' | 'patch' | 'delete', Path extends keyof paths> = Exclude<
	FetchResponse<
		Method extends infer T
			? T extends 'delete'
				? T extends keyof paths[Path]
					? Record<string, string>
					: never
				: T extends 'get' | 'post' | 'put' | 'patch'
					? T extends keyof paths[Path]
						? paths[Path][T]
						: never
					: never
			: never,
		'json',
		'application/json'
	>['data'],
	undefined
>;

export type ApiBody<Method extends 'post' | 'put' | 'patch' | 'delete', Path extends keyof paths> = FetchOptions<
	paths[Path][Method]
>['body'];

export type ApiQuery<
	Method extends 'get' | 'post' | 'put' | 'patch' | 'delete',
	Path extends keyof paths,
> = NonNullable<FetchOptions<paths[Path][Method]>['params']>['query'];

export function objectToFormData(data: Record<string, unknown>, prefix?: string, form = new FormData()) {
	for (const [key, val] of Object.entries(data)) {
		if (Array.isArray(val)) {
			val.forEach((v) => {
				form.append(`${prefix ? `${prefix}.` : ''}${key}`, v.toString());
			});
		}
		if (typeof val === 'string' || typeof val === 'number') {
			form.set(`${prefix ? `${prefix}.` : ''}${key}`, val.toString());
		} else if (typeof val === 'object' && val) {
			objectToFormData(val as Record<string, unknown>, key, form);
		}
	}
	return form;
}
